import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const InvoiceAuditModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5714 2.71366C11.7656 2.39025 12.2344 2.39025 12.4286 2.71366L13.735 4.88875C13.869 5.11185 14.1517 5.19486 14.385 5.07962L16.66 3.9561C16.9982 3.78904 17.3926 4.04248 17.3812 4.41957L17.3042 6.95566C17.2963 7.21577 17.4893 7.43845 17.7479 7.46766L20.2691 7.75242C20.644 7.79476 20.8387 8.22117 20.6252 8.53221L19.1894 10.6241C19.0421 10.8387 19.084 11.1303 19.2858 11.2947L21.2528 12.8973C21.5453 13.1356 21.4786 13.5996 21.1308 13.7459L18.7919 14.7294C18.5521 14.8303 18.4297 15.0983 18.5105 15.3456L19.2988 17.7573C19.4161 18.1159 19.1091 18.4702 18.7375 18.4052L16.2381 17.9681C15.9818 17.9233 15.7339 18.0826 15.6682 18.3344L15.0275 20.7894C14.9323 21.1545 14.4825 21.2865 14.205 21.0309L12.3387 19.312C12.1473 19.1357 11.8527 19.1357 11.6613 19.312L9.79501 21.0309C9.51751 21.2865 9.06773 21.1545 8.97247 20.7894L8.3318 18.3344C8.26609 18.0826 8.01822 17.9233 7.76187 17.9681L5.26255 18.4052C4.89092 18.4702 4.58394 18.1159 4.70116 17.7573L5.48949 15.3456C5.57034 15.0983 5.44794 14.8303 5.20805 14.7294L2.86918 13.7459C2.52142 13.5996 2.4547 13.1356 2.74718 12.8973L4.71422 11.2947C4.91597 11.1303 4.9579 10.8387 4.81063 10.6241L3.37479 8.53221C3.16129 8.22117 3.35603 7.79476 3.73091 7.75242L6.25213 7.46766C6.51072 7.43845 6.70368 7.21577 6.69579 6.95566L6.61884 4.41957C6.6074 4.04248 7.00175 3.78904 7.34001 3.9561L9.61495 5.07962C9.84829 5.19486 10.131 5.11185 10.265 4.88875L11.5714 2.71366Z"
            fill="url(#paint0_linear_227_638)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.0492 9.70454C15.3219 9.97727 15.3219 10.4194 15.0492 10.6922L11.5574 14.184C11.2847 14.4567 10.8425 14.4567 10.5698 14.184L9.17305 12.7872C8.90032 12.5145 8.90032 12.0723 9.17305 11.7996C9.44577 11.5269 9.88795 11.5269 10.1607 11.7996L11.0636 12.7025L14.0615 9.70454C14.3343 9.43182 14.7764 9.43182 15.0492 9.70454Z"
            fill="#394504"
          />
          <defs>
            <linearGradient
              id="paint0_linear_227_638"
              x1="12"
              y1="2"
              x2="12"
              y2="22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4EC623" />
              <stop offset="1" stop-color="#D5F939" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default InvoiceAuditModule;
